// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2NYv7","box":"WorkspacesBox_box__1PfPk","node":"WorkspacesBox_node__3GvUo"};